import React from "react";
import FormBlock from "../Default/FormBlock";
import { wording } from "../DataForForm/Wording";

function DrugOrBoxProblemBlock({
  parentCallback,
  appProOrNotpro,
  selectedValue,
}) {
  const grandPublic = wording.grand_public.drug_or_box_problem;
  const pro = wording.pro.drug_or_box_problem;
  const items = appProOrNotpro !== "Patient" ? pro : grandPublic;

  return (
    <FormBlock
      parentCallback={parentCallback}
      selectedValue={selectedValue}
      items={items}
    ></FormBlock>
  );
}

export default DrugOrBoxProblemBlock;
